import { BetaPill, DatevLogo } from '@components'
import { useShowDatevComingSoon } from '@hooks'
import { SettingsSubNavItem } from '@pages/SettingsPage/components/SettingsSubNavItem'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  isActive: boolean
  onSelect: () => void
}

export const DatevSettingsNavItem: React.FC<Props> = ({ isActive, onSelect }) => {
  const { t } = useTranslation()
  const showDatevComingSoon = useShowDatevComingSoon()

  if (!showDatevComingSoon) {
    return null
  }

  return (
    <SettingsSubNavItem
      link="datev"
      icon={<DatevLogo height={16} />}
      name={t('settings.sections.datevIntegration')}
      isActive={isActive}
      onSelect={() => onSelect()}
      suffix={
        <BetaPill label={t('general.comingSoon.label')} tooltip={t('general.comingSoon.tooltip')} />
      }
    />
  )
}
